// @flow

import React from 'react';
import { connect } from 'react-redux';
import ActiveFiltersComponent from './activeFilters';
import {
  getSelectedFilters,
  deleteRangeFilter,
  toggleTermFilter,
  toggleCustomFilter,
} from '../../../store/assortment';

type OwnProps = {|
  className?: string,
|};

type StateProps = {|
  filters: Array<{
    id: string,
    value: string,
    type: string,
  }>,
|};

type DispatchProps = {|
  removeFilter: (label: string, type: string, bucket: string) => void,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
  ...OwnProps,
|};

const ActiveFilters = ({
  filters,
  removeFilter,
  className,
}: Props) => (
  <ActiveFiltersComponent
    className={className}
    filters={filters}
    onDelete={(id, type, value) => removeFilter(id, type, value)}
  />
);

const mapStateToProps = (state): StateProps => ({
  filters: getSelectedFilters(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  removeFilter: (label, type, bucket) => {
    switch (type) {
      case 'term':
        dispatch(toggleTermFilter(label, bucket));
        break;
      case 'custom':
        dispatch(toggleCustomFilter(label));
        break;
      case 'range':
        dispatch(deleteRangeFilter(label));
        break;
      default:
        break;
    }
  },
});

ActiveFilters.defaultProps = {
  className: '',
};

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(ActiveFilters);
